"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidthContext = void 0;
var react_1 = require("react");
exports.WidthContext = react_1.createContext({ width: null });
exports.default = (function () { return react_1.useContext(exports.WidthContext); });
//# sourceMappingURL=index.js.map